import api from "../../services/api";
import formatDate, { addMinutesToDate, convertDateStringToDate } from "../formatDate";
import ApplicationConfig from "../../config";

/**
 * User login
 */
const login = async (credentials: { email: string; password: string }) => {
    const response = await api.post('/auth/login', credentials)
    return response.data
}

/**
 * Verify access token
 */
const verifyAccessToken = async() => {
    const response = await api.post('/auth/token/verify')
    return response.data
}

/**
 * Enable 2FA
 */
const enable2FA = async() => {
    const response = await api.post('/auth/two-factor-auth/enable')
    return response
}

/**
 * Disable 2FA
 */
const disable2FA = async() => {
    const response = await api.post('/auth/two-factor-auth/disable')
    return response
}

/**
 * Verify 2FA
 */
const verify2FA = async(otp: number) => {
    const response = await api.post('/auth/two-factor-auth/verify', { otp })
    return response
}

/**
 * Refresh Access Token
 */
const refreshAccessToken = async() => {
    const response = await api.post('/auth/token/refresh')
    return response.data
}

/**
 * Refresh Access Token
 */
const logout = async() => {
    const response = await api.post('/auth/logout')
    return response.data
}

/**
 * Update local storage
 */
export const updateAuthLocalStorage = () => {
    localStorage.setItem('tokenRefreshedTime', formatDate(new Date()));
    localStorage.setItem('isAuthenticated', "true");
}

/**
 * Clear local storage
 */
export const clearAuthLocalStorage = () => {
    localStorage.removeItem("tokenRefreshedTime")
    localStorage.removeItem("isAuthenticated")
}

/**
 * Check if the token expired based on the date
 */
export const isRefreshTokenExpired = () => {
    const tokenIssueDate = localStorage.getItem("tokenRefreshedTime")

    if (tokenIssueDate){
        const tokenExpiryDate = addMinutesToDate(convertDateStringToDate(tokenIssueDate), ApplicationConfig.authConfig.accessTokenExpiryInMin)
        const now = new Date()

        if (tokenExpiryDate < now){
            return false
        }else{
            return true
        }
    }

    return false
}


const AuthService = {
    login,
    logout,
    verifyAccessToken,
    refreshAccessToken,
    enable2FA,
    verify2FA,
    disable2FA
}  
export default AuthService;